// Framework and third-party non-ui
import React from "react";

// App components
import { makeStyles } from "@material-ui/core/styles";

const Options = ({ clickedOption, setClickedOption }) => {
  const useStyles = makeStyles({
    container: {
      display: "flex",
      justifyContent: "space-around",
      textTransform: "uppercase",
      width: "100%",
      padding: "25px 0",
      height: "34px",
      position: "absolute",
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "14px",
      lineHeight: "16px",
      textAlign: "center",
      letterSpacing: "1.25px",
      color: "#22471B",
    },
    nonClicked: {
      borderStyle: "none",
      cursor: "pointer",
    },
    clicked: {
      borderBottom: "5px solid #4D7343",
      cursor: "pointer",
    },
  });

  const classes = useStyles();

  const handleTrailsClick = (event) => {
    event.preventDefault();
    setClickedOption("Trails");
  };

  const handleFeaturedClick = (event) => {
    event.preventDefault();
    setClickedOption("Featured");
  };

  return (
    <div className={classes.container}>
      <div
        href="#"
        class={
          clickedOption === "Trails" ? classes.clicked : classes.nonClicked
        }
        onClick={handleTrailsClick}
      >
        Trails
      </div>
      {/* <div
        href="#"
        class={
          clickedOption === "Featured" ? classes.clicked : classes.nonClicked
        }
        onClick={handleFeaturedClick}
      >
        Featured
      </div> */}
    </div>
  );
};

export default Options;
